export class PAYMENT_METHODS {
  static readonly CYBERSOURCE_CREDIT_CARD = 'CYBERSOURCE_CREDIT_CARD';
  static readonly PAYPAL = 'PAYPAL';
  static readonly APPLE_PAY = 'APPLE_PAY';
  static readonly AMAZON_PAY = 'AMAZON_PAY';
  static readonly GOOGLE_PAY = 'GOOGLE_PAY';
  static readonly BREADPAYMENT = 'BREAD_PAYMENT';
}

export enum PAYMENT_TYPES {
  SCHEME = 'scheme',
  BREADPAYMENT = 'breadpayment',
  PAYPAL = 'paypal',
  SAVED_CARD = 'savedCard',
}

export const CYBERSOURCE_PAYMENT_PROVIDER = 'CYBERSOURCE';
export const BREAD_PAYMENT_PROVIDER = 'BREADPAY';

export const CYBERSOURCE_CARDS_TYPES_MAP = {
  '001': 'VISA',
  '002': 'MASTERCARD',
  '003': 'AMERICAN_EXPRESS',
  '004': 'DISCOVER',
  '005': 'DINERS_CLUB',
  '006': 'CARTE_BLANCHE',
  '007': 'JCB',
  '008': 'OPTIMA',
  '011': 'TWINPAY_CREDIT',
  '012': 'TWINPAY_DEBIT',
  '013': 'WALMART',
  '014': 'ENROUTE',
  '015': 'LOWES_CONSUMER',
  '016': 'HOME_DEPOT_CONSUMER',
  '017': 'MBNA',
  '018': 'DICKS_SPORTSWEAR',
  '019': 'CASUAL_CORNER',
  '020': 'SEARS',
  '021': 'JAL',
  '023': 'DISNEY',
  '024': 'MAESTRO_UK_DOMESTIC',
  '025': 'SAMS_CLUB_CONSUMER',
  '026': 'SAMS_CLUB_BUSINESS',
  '028': 'BILL_ME_LATER',
  '029': 'BEBE',
  '030': 'RESTORATION_HARDWARE',
  '031': 'DELTA_ONLINE',
  '032': 'SOLO',
  '033': 'VISA_ELECTRON',
  '034': 'DANKORT',
  '035': 'LASER',
  '036': 'CARTE_BLEUE',
  '037': 'CARTA_SI',
  '038': 'PINLESS_DEBIT',
  '039': 'ENCODED_ACCOUNT',
  '040': 'UATP',
  '041': 'HOUSEHOLD',
  '042': 'MAESTRO_INTERNATIONAL',
  '043': 'GE_MONEY_UK',
  '044': 'KOREAN_CARDS',
  '045': 'STYLE',
  '046': 'JCREW',
  '047': 'PAYEASE',
  '048': 'PAYEASE',
  '049': 'MEIJER_PRIVATE_LABEL',
  '050': 'HIPERCARD',
  '051': 'AURA',
  '052': 'REDECARD',
  '054': 'ELO',
  '055': 'CAPITAL_ONE_PRIVATE_LABEL',
  '056': 'SYNCHRONY_PRIVATE_LABEL',
  '057': 'COSTCO_PRIVATE_LABEL',
  '060': 'MADA',
  '062': 'CHINA_UNION_PAY',
  '063': 'FALABELLA_PRIVATE_LABEL',
};

export const CARD_IMAGE = {
  AMERICAN_EXPRESS: '/images/amex.svg',
  DISCOVER: '/images/disc.svg',
  MASTERCARD: '/images/mc.svg',
  VISA: '/images/visa.svg',
};
